import { type ComponentRef, Directive, input, output, type Type } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import { takeUntil } from 'rxjs/operators';
import { BoardsSidebarContextMenuComponent } from './boards-sidebar-context-menu/boards-sidebar-context-menu.component';

/** Right-click menu of a sidebar row (All boards … Trash, and Folders), like Sheets' `appSidebarContextMenu`: Add new
 * board, Add new folder and the row's bulk action, where the row has them. A no-op (renders nothing) on a row without any.
 * Takes a plain `string` (the sidebar's own `SidebarItem.id`, or `folders`), not `BoardSidebarView`, so it can bind
 * straight to `item.id` in the `@for` loop; the component narrows it internally. */
@Directive({
  selector: '[appBoardsSidebarContextMenu]',
  standalone: true,
})
export class BoardsSidebarContextMenuDirective extends ContextMenuDirective {
  public readonly appBoardsSidebarContextMenu = input.required<string>();
  public readonly appBoardsSidebarContextMenuFolderCreated = output<string>();

  protected registerComponent(): Type<BoardsSidebarContextMenuComponent> {
    return BoardsSidebarContextMenuComponent;
  }

  protected registerInstance(componentRef: ComponentRef<BoardsSidebarContextMenuComponent>): void {
    componentRef.setInput('view', this.appBoardsSidebarContextMenu());
    outputToObservable<string>(componentRef.instance.folderCreated)
      .pipe(takeUntil(this.alive))
      .subscribe((id) => this.appBoardsSidebarContextMenuFolderCreated.emit(id));
  }
}
